import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleFineApiService } from '../infra/api.service';
import {
  FineStatusEnum,
  VehicleFine,
  VehicleFineCreateParams,
  VehicleFineFindAllParams,
  VehicleFineSummary,
  VehicleFineSummaryParams,
  VehicleFineUpdateParams,
} from './type';

@Injectable({ providedIn: 'root', useClass: VehicleFineApiService })
export abstract class VehicleFineService {
  abstract findAll(
    filter?: VehicleFineFindAllParams,
  ): Observable<PaginatedResponse<VehicleFine>>;

  abstract getSummary(
    params?: VehicleFineSummaryParams,
  ): Observable<VehicleFineSummary>;

  abstract create(params: VehicleFineCreateParams): Observable<VehicleFine>;

  abstract update(
    id: number,
    params: VehicleFineUpdateParams,
  ): Observable<VehicleFine>;

  abstract updateStatus(
    id: number,
    status: FineStatusEnum,
  ): Observable<VehicleFine>;

  abstract remove(id: number): Observable<{ id: number }>;
}
